export default __webpack_public_path__ + "static/media/build-asset.65d96c91.png";